import { css } from 'styled-components';

export const Inputbox = css`
  position: relative;
  display: block;
  width: 100%;
`;

export const Input = css`
  position: relative;
  display: block;
  width: 100%;
  height: 67px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.borderColor};
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.background};
  outline: none;
  transition: 0.2s all;
  font-size: 21px;
  font-weight: 500;
  text-align: left;

  ::-webkit-input-placeholder {
    color: ${(props) => props.theme.colorPlaceholder};
  }

  ${(props) =>
    props.valid &&
    css`
      border: 1px solid ${(props) => props.theme.borderColorOnValid};
    `};

  ${(props) =>
    props.invalid &&
    css`
      border: 1px solid ${(props) => props.theme.borderColorOnInvalid};
    `};

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.35;
    `};
`;

export const InputError = css`
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 4px 12px 0;
  color: ${(props) => props.theme.color};
  font-size: 12px;
  line-height: 1.2;
  min-height: 25px;
  cursor: default;
`;
